export const CompanyOnboardingStrings =
{
    backToIdentities: "Volver a Gestión de Intervinientes",
    stepperAriaLabel: "Pasos del alta de empresa",
    cancel: "Cancelar",
    representativeNewTitle: "Añadir representante",
    representativeNewSubtitle: "Para dar de alta a un representante solo necesitamos su DNI.",
    representativeReuseInfo: "Un mismo representante puede asociarse a varias empresas. Lo darás de alta una sola vez y lo seleccionarás en cada alta de empresa.",
    representativeIdDocumentTitle: "DNI del representante",
    representativeIdDocumentDescription: "Sube las dos caras del DNI en vigor. Leeremos los datos automáticamente.",
    idDocumentFront: "Anverso",
    idDocumentBack: "Reverso",
    idDocumentDropHint: "Arrastra aquí la imagen o selecciónala · PDF, JPG o PNG",
    idDocumentSelect: "Seleccionar archivo",
    idDocumentReplace: "Reemplazar",
    idDocumentInvalidFormat: "Formato no admitido. Sube un archivo PDF, JPG o PNG.",
    readIdDocument: "Leer datos del DNI",
    readingIdDocument: "Leyendo el DNI…",
    idReadingIncomplete: "No hemos podido leer todos los datos del DNI. Revisa los que aparecen y completa los que falten.",
    idDataTitle: "Datos del DNI",
    idDataDescription: "Revisa que coinciden con el documento y corrígelos si es necesario.",
    permanentIdExpiration: "Documento de validez permanente",
    additionalDataTitle: "Datos adicionales",
    additionalDataDescription: "Datos que no aparecen en el DNI y que necesitamos para darle de alta como cliente.",
    fatcaBlocked: "Alta no permitida por operativa.",
    representativeAlreadyExists: "Esta persona ya está dada de alta en IronIA",
    representativeIsDiaphanumClient: "Esta persona ya es cliente de Diaphanum, pero todavía no está dada de alta en IronIA",
    representativeIsDiaphanumClientHint: "Para poder seleccionarla como representante de la empresa tenemos que darla de alta nosotros. Escríbenos a info@ironia.tech indicando la empresa y te avisaremos cuando esté lista.",
    representativeAlreadyExistsHint: "No hace falta volver a darla de alta: si es uno de tus intervinientes podrás seleccionarla en el alta de la empresa. Si no aparece entre ellos, gestiónala desde Gestión de Intervinientes.",
    representativeOwnedByOtherUser: "Esta persona ya está dada de alta en IronIA por otro usuario",
    representativeOwnedByOtherUserHint: "Puedes solicitar acceso a su titular. Cuando lo apruebe aparecerá en Gestión de Intervinientes y podrás seleccionarla como representante en el alta de la empresa.",
    requestAccess: "Solicitar acceso",
    requestingAccess: "Solicitando…",
    accessRequested: "Solicitud de acceso enviada",
    accessRequestedHint: "Cuando el titular la apruebe aparecerá en Gestión de Intervinientes. Mientras tanto puedes dar de alta a otros representantes.",
    accessRequestGenericError: "No se ha podido enviar la solicitud de acceso. Inténtalo de nuevo más tarde.",
    representativeSubmit: "Dar de alta representante",
    representativeSubmitting: "Dando de alta…",
    representativeMissingFields: "Para continuar, completa estos campos:",
    representativeCreated: "Representante dado de alta",
    representativeCreatedHint: "Ya puedes seleccionarlo como representante en el alta de la empresa.",
    submitGenericError: "No se ha podido dar de alta al representante. Inténtalo de nuevo más tarde.",
    addAnotherRepresentative: "Añadir otro representante",
    continueWithCompany: "Continuar con el alta de empresa",
    // Paso 2: suscripción
    back: "Volver atrás",
    subscriptionTitle: "Alta de empresa en IronIA Fintech",
    subscriptionSubtitle: "Indica la empresa, realiza el pago y completa el alta.",
    usTaxResidenceWarning: "No podemos permitir el alta de empresas con residencia fiscal en Estados Unidos o sujetas a obligaciones de reporte FATCA. Si la empresa se encuentra en alguna de estas situaciones, no podrás continuar con el proceso de alta.",
    subscriptionHolderTitle: "Empresa titular de la suscripción",
    subscriptionHolderDescription: "La empresa será la titular de la suscripción. El resto de datos, la documentación y sus representantes se completan en el siguiente paso.",
    orderSummaryTitle: "Resumen del pedido",
    orderPlan: "Plan",
    orderPlanName: "IronIA Empresa",
    orderFirstYear: "Alta de empresa (primer año)",
    orderRenewal: "Facturación anual a partir del 2º año",
    orderTotalToday: "Total hoy",
    makePayment: "Realizar pago",
    paymentPending: "Empresa guardada como borrador. El pago se conectará más adelante.",
    savingCompany: "Guardando…",
    companyDraftGenericError: "No se ha podido guardar la empresa. Inténtalo de nuevo más tarde.",
    continueToCompanyDetails: "Continuar con los datos de la empresa",
    // Paso 3: datos de la empresa
    detailsTitle: "Alta de empresa",
    detailsSubtitle: "Completa los datos de la persona jurídica que quieres asociar a tu usuario.",
    detailsLoading: "Cargando la empresa…",
    detailsLoadError: "No hemos podido cargar la empresa. Vuelve a Gestión de Intervinientes y entra de nuevo.",
    detailsNoCompany: "No se ha indicado la empresa. Entra desde Gestión de Intervinientes.",
    detailsReadOnly: "Esta empresa ya se ha enviado y sus datos no se pueden modificar.",
    basicInfoTitle: "Información básica",
    basicInfoDescription: "Denominación, identificación fiscal y datos de constitución.",
    registryTitle: "Registro mercantil",
    registryDescription: "Datos de inscripción y de la escritura de constitución.",
    addressesTitle: "Domicilios",
    addressesDescription: "Domicilio fiscal y domicilio social de la empresa.",
    fiscalAddress: "Domicilio fiscal",
    registeredAddress: "Domicilio social",
    registeredAddressSameAsFiscal: "Mismo que el domicilio fiscal",
    contactTitle: "Datos de contacto",
    contactDescription: "Un único correo electrónico y un único teléfono de la empresa.",
    documentsTitle: "Documentación",
    documentsDescription: "Documentos de constitución y documento CIF de la empresa.",
    incorporationDocuments: "Documentos de constitución",
    incorporationDocumentsHint: "Puedes adjuntar varios documentos. Solo PDF · máx. 10 MB por archivo.",
    taxIdDocument: "Documento CIF",
    taxIdDocumentHint: "Documento único y obligatorio, en PDF. Si adjuntas otro, sustituye al anterior.",
    companyDocumentDropHint: "Arrastra aquí el documento o selecciónalo · PDF · máx. 10 MB",
    selectFiles: "Seleccionar archivos",
    selectFile: "Seleccionar archivo",
    uploadingDocument: "Subiendo…",
    noDocuments: "No se han añadido documentos",
    removeDocument: "Quitar",
    representativesTitle: "Selección de representantes",
    representativesDescription: "Elige entre los intervinientes que ya has dado de alta e indica su rol, su firma y, si es titular real, su porcentaje de titularidad.",
    representativesInfo: "Un representante puede estar asociado a varias empresas. ¿No lo encuentras? Debe darse de alta antes como interviniente (solo necesita su DNI).",
    addRepresentative: "Añadir representante",
    representativeSearchPlaceholder: "Selecciona un interviniente",
    noSelectableRepresentatives: "No tienes intervinientes que puedan ser representantes. Da de alta primero a los representantes con su DNI.",
    borrowedRepresentative: "Prestado",
    removeRepresentative: "Quitar representante",
    declaration: "Declaro que los datos facilitados son veraces y están actualizados.",
    saveDraft: "Guardar borrador",
    savingDraft: "Guardando…",
    draftSaved: "Borrador guardado.",
    continueToKyc: "Continuar a KYC empresa",
    detailsIncomplete: "Revisa lo siguiente para continuar:",
    cnaeLoadError: "No hemos podido cargar el catálogo de actividades (CNAE). Vuelve a cargar la página.",
    cnaeSearchPlaceholder: "Busca por código o actividad",
    detailsGenericError: "No se han podido guardar los datos de la empresa. Inténtalo de nuevo más tarde.",
    documentGenericError: "No se ha podido subir el documento. Inténtalo de nuevo más tarde.",
    afterPaymentInfo: "Tras el pago completarás los datos de la empresa y seleccionarás a sus representantes entre los intervinientes que ya has dado de alta. La empresa quedará activa cuando Diaphanum finalice el bastanteo.",
    // Paso 4: KYC de la empresa
    kycTitle: "Conocer al cliente (KYC) de la empresa",
    kycSubtitle: "Información requerida por la normativa de prevención de blanqueo de capitales.",
    kycLoading: "Cargando el KYC de la empresa…",
    kycLoadError: "No hemos podido cargar el KYC de la empresa. Vuelve a Gestión de Intervinientes y entra de nuevo.",
    kycReadOnly: "El KYC de esta empresa ya se ha enviado y no se puede modificar.",
    pepTitle: "Persona políticamente expuesta (PEP)",
    pepNavTitle: "Persona expuesta (PEP)",
    pepDescription: "Relación de la empresa o sus titulares con cargos públicos relevantes.",
    riskCountriesTitle: "Países de riesgo",
    riskCountriesDescription: "Operativa con jurisdicciones de riesgo.",
    riskCountriesPlaceholder: "Selecciona uno o varios países",
    corporateTitle: "Otros datos societarios",
    corporateNavTitle: "Datos societarios",
    corporateDescription: "Estructura y cotización de la sociedad.",
    fundsTitle: "Actividad y origen de fondos",
    fundsNavTitle: "Actividad y fondos",
    fundsDescription: "Procedencia del patrimonio que se va a invertir.",
    fundsOriginPlaceholder: "Selecciona uno o varios",
    proofOfIncomeDocuments: "Documentos de pruebas de ingresos",
    proofOfIncomeDocumentsHint: "Se admiten varios documentos en formato PDF. Cuentas anuales, impuesto de sociedades…",
    proofOfIncomeDropHint: "Arrastra aquí los documentos o selecciónalos · PDF · máx. 10 MB por archivo",
    proofOfIncomeCategory: "Pruebas de ingresos",
    fatcaTitle: "FATCA",
    fatcaDescription: "Datos relativos a Estados Unidos.",
    previousStep: "Anterior",
    sendToReview: "Enviar a bastanteo",
    kycIncomplete: "Revisa lo siguiente para enviar a bastanteo:",
    kycComplete: "Empresa enviada a bastanteo",
    kycCompleteHint: "Hemos enviado la empresa a Diaphanum para la revisión de poderes (bastanteo). Te avisaremos cuando esté operativa.",
    kycGenericError: "No se ha podido guardar el KYC de la empresa. Inténtalo de nuevo más tarde.",
    kycSubmitError: "Hemos guardado el KYC, pero no hemos podido enviar la empresa a revisión. Inténtalo de nuevo en unos minutos.",
};
